module.exports = __webpack_public_path__ + "img/df6f7ad2b9c7407d9fcda7b92fc181f4.ef15c761.png";